// @flow

import { connect } from 'react-redux';

import SearchResults from './searchresults';
import { User } from '../../../models/user';
import { updateSearchParam, resetSearchPrams } from '../../../services/search';
import { resetWorkTabs } from '../../../services/ui';

export type Props = {
  fetching: boolean,
  authenticating: boolean,
  count: number,
  search: any,
  searchParams: any,
  location: RouteComponentProps,
  user: User,
  headerIcon: string,
  backLinkOnClick: () => void,
  getWorks: () => void,
  updateSearchParam: (name: string, value: string) => void,
  resetSearchPrams: () => void,
};

const mapState = ({ authentication, search, tnc }) => ({
  authenticating: authentication.authenticating,
  user: authentication.user,
  fetching: search.fetching,
  count: (search.search && search.search.count) || 0,
  search: (search.search && search.search.data && search.search.data.workSummaryList) || [],
  searchParams: search.searchParams,
  sodtncAccepted: tnc.sodtncAccepted,
});

const mapDispatch = {
  updateSearchParam,
  resetSearchPrams,
  resetWorkTabs,
};

export default connect(
  mapState,
  mapDispatch,
)(SearchResults);
